<template>
  <div class="content">
    <div class="header">
      <el-select v-model="listQuery.type" @change="search" size="mini" style="margin-right: 10px;width: 120px;" clearable placeholder="培训状态">
        <el-option label="未开始" :value="1"></el-option>
        <el-option label="进行中" :value="2"></el-option>
        <el-option label="已结束" :value="3"></el-option>
      </el-select>
      <eleSelect
      placeDefult="请选择培训类别"
      style="width:200px;margin-right:10px;"
      size="mini"
      :width="200"
      :NamespaceId="53"
      @selectData="searchJzFun"
      ></eleSelect>
      <el-input 
      style="margin-right:10px;width:200px;" 
      size="mini" 
      placeholder="请输入班级名称" 
      v-model="listQuery.title" 
      clearable></el-input>
      <el-button type="primary" size="mini" icon="el-icon-search" @click="search">搜索</el-button>
    </div>
    <div class="metter" v-if="trainData.length!==0">
      <el-table ref="JLTable" :data="trainData" border height="480px" style="width:100%;">
        <el-table-column prop="title" label="名称" align="left" show-overflow-tooltip min-width="280">
          <template slot-scope="scope">
            <span
              type="primary"
              size="mini"
            >{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="120px"
          min-height="140px"
          :label="'类别'"
          prop="catedicname"
          show-overflow-tooltip
          align="center"
        ></el-table-column>

        <el-table-column min-height="140px" width="100px" :label="'开始时间'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.startime.substring(0, 10) }}</span>
          </template>
        </el-table-column>
        <el-table-column min-height="140px" width="100px" :label="'结束时间'" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.endtime.substring(0, 10) }}</span>
          </template>
        </el-table-column>
        
        <el-table-column width="80px" min-height="140px" label="培训状态" prop="stateName" align="center"></el-table-column>
        <el-table-column width="120px" min-height="140px" label="审核验印状态" prop="stateName" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.alarmtype === 0">待班主任鉴定</span>
            <span v-else-if="scope.row.alarmtype === 1">院校鉴定中</span>
            <span v-else-if="scope.row.alarmtype === 2">省级鉴定中</span>
            <span v-else-if="scope.row.alarmtype === 5">鉴定完毕</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          :label="'操作'"
          width="200"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button type="primary" @click.prevent="openScoreFun(scope.row)" plain size="mini">成绩管理</el-button>
            <el-button type="primary" @click.prevent="seeTeachrLogsFun(scope.row)" plain size="mini">日志管理</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="listQuery.limit"
        layout="total,sizes, prev, pager, next"
        :total="trainCount"
        v-if="trainCount"
      ></el-pagination>
    </div>

    <!-- 日志管理 -->
    <el-dialog
    title="日志管理"
    :visible.sync="logFileSetDlogShow"
    width="1200px"
    destroy-on-close
    v-if="logFileSetDlogShow"
    >
      <teachrLogFilesDlog :trainId="trainId" :trainName="trainName"></teachrLogFilesDlog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logFileSetDlogShow = false">取 消</el-button>
        <el-button @click="logFileSetDlogShow = false" type="primary">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 成绩管理 -->
    <el-dialog
    title="成绩管理"
    :visible.sync="scoreDialogShow"
    width="1450px"
    class="dialog-mini"
    destroy-on-close
    top="8vh"
    >
      <scoreManage
      :trainId="trainId"
      :trainTitle="trainName"
      :alarmtype="alarmtype"
      ></scoreManage>
    </el-dialog>
  </div>
</template>
<script>
import {
  getclassTearchLogListApi
} from '@/api/personcenter/index';
import teachrLogFilesDlog from './component/teachrLogFilesDlog.vue';
import scoreManage from './component/scoreManage.vue';
import eleSelect from '@/components/elSelect/index.vue';
export default {
  components: {
    teachrLogFilesDlog,
    scoreManage,
    eleSelect
  },
  name: 'iamClasserLogs',
  data() {
    return {
      labledata: [
        { name: '全部', id: 0 },
        { name: '未开始', id: 1 },
        { name: '进行中', id: 2 },
        { name: '已结束', id: 3 },
      ],
      listQuery: {
        title: null,
        CateDicId: null,
        page: 1,
        limit: 10,
        userId: this.$store.state.User.ids,
        type: null,
      },
      lableindex: 0,
      trainData: [],
      trainCount: 0,
      logFileSetDlogShow: false,
      trainId: 0,
      trainName: '',
      scoreDialogShow: false,
      alarmtype: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //搜索培训类别
    searchJzFun(row){
      this.listQuery.CateDicId = row.value;
      this.search();
    },
    //搜索
    search(){
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    //获取教历列表
    getList(){
      this.listQuery.type = this.listQuery.type ? this.listQuery.type : null;
      getclassTearchLogListApi(this.listQuery).then((res) => {
        this.trainData = res.data;
        this.trainCount = res.count;
      });
    },
    //查看日志
    seeTeachrLogsFun(row){
      this.trainId = row.id;
      this.trainName = row.title;
      this.logFileSetDlogShow = true;
    },
    //打开成绩管理
    openScoreFun(row){
      this.trainId = row.id;
      this.trainName = row.title;
      this.alarmtype = row.alarmtype;
      this.scoreDialogShow = true;
    },
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  /* height: 1000px; */
  padding-bottom: 20px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  box-sizing: border-box;
  min-height: 35px;
  border-bottom: solid 1px #ccc;
  padding: 10px;
  padding-top: 20px;
}

.nav {
  width: 800px;
  height: 180px;
  /* background-color: blue; */
  margin-top: 16px;
  border-radius: 10px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 1);
  /* box-shadow: 2px 2px 5px rgba(215, 215, 215, 0.968627450980392); */

  border: 1px solid #f2f2f2;
  /* padding-left: 16px; */
  padding-top: 16px;
  margin-left: 20px;
}
/* .nav:hover{
    box-shadow:  2px 2px 5px rgba(52, 194, 250, 0.969)!important
} */
.navfirst {
  font-weight: 700;
  padding: 0 20px;
  font-size: 16px;
  border-bottom: solid 1px #f2f2f2;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
hr {
  margin-top: 10px;
}
.navsecond {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  border-bottom: solid 1px #f2f2f2;
  padding-bottom: 10px;
}
.navsecond > div {
  line-height: 50px;
  width: 370px;
  /* text-align: center; */
  padding-left: 20px;
  color: #666;
  font-size: 14px;
}
.navthirt {
  padding-top: 10px;
  padding-left: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}

.title1deta:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #1492ff;
}
</style>